import { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import DownloadButton from '@/components/Elements/Button/DownloadButton'
import ViewFileButton from '@/components/Elements/Button/ViewFileButton'
import { Flex, Text, Input, Button } from '@chakra-ui/react'

import { setFileHistoryModal } from '@/stores/ui/uiSlice'

const MultipleFileViewCell = ({
  getValue,
  row: { index, original },
  column: { id },
  table,
  title = '',
  extraDisable = false,
  fileType,
}) => {
  const files = getValue()
  const fileCount = Array.isArray(files) ? files.length : 0

  const isDisabled = table.options.meta?.disabled || extraDisable

  const dispatch = useDispatch()

  const handleOpenViewFilesModal = useCallback(
    (files) => {
      dispatch(
        setFileHistoryModal({
          show: true,
          title: title,
          files: files,
        })
      )
    },
    [dispatch, title]
  )

  return (
    <Button colorScheme="blue" onClick={() => handleOpenViewFilesModal(files)}>
      Detail ({fileCount})
    </Button>
  )
}

export default MultipleFileViewCell
